module.exports = __webpack_public_path__ + "img/accessory_shoe_07.a5cdab53.svg";